import { gqlQuery, gqlMutate } from './common/apolloClient'
import {
  gqlGetVehiclesCategory,
  gqlActivateIdentification,
  gqlNewIdentifier,
  gqlDesabilitarIdentificador,
  gqlSubstituirIdentificador
} from './queries/vehicles'

export async function getVehiclesCategory(categoria) {
  const payload = { categoria }
  const response = await gqlQuery(gqlGetVehiclesCategory, payload)
  return response.data.consultaCategorias
}

export async function activateIdentifier(data) {
  const payload = {
    placa: data.plate,
    categoria:
      data.typeCar === 'carro-passeio' || data.typeCar === 'carro-utilitario'
        ? 'DOIS_EIXOS_RODAGEM_SIMPLES'
        : data.axis,
    id: data.accountId,
    tipoProduto: data.type === 'pre' ? 'PRE_PAGO' : 'POS_PAGO',
    codIdentificador: data.identifier || '',
    tipoIdentificador: 'TAG'
  }
  const { data: respData } = await gqlMutate(gqlActivateIdentification, payload)
  if (respData && respData.identificadorAtivar.error && respData.identificadorAtivar.error[0]) {
    const error = new Error('Erro ao ativa identificador')
    error.json = async () => respData.identificadorAtivar.error[0]
    throw error
  }
  return { status: 200, ...respData }
}

export async function newIdentifier(data) {
  const payload = {
    id: data.codigoConta,
    endereco: {
      cep: data.endereco.cep,
      logradouro: data.endereco.logradouro,
      numero: data.endereco.numero,
      complemento: data.endereco.complemento,
      bairro: data.endereco.bairro,
      uf: data.endereco.uf,
      cidade: data.endereco.cidade
    },
    quantidadeIdentificadores: Number(data.quantidadeIdentificadores)
  }
  const response = await gqlMutate(gqlNewIdentifier, payload)
  return response
}

export async function replaceIdentifier(data) {
  const payload = {
    codigoConta: data.codigoConta,
    codigoIdentificador: data.codigoIdentificador,
    motivoInativacao: data.motivoInativacaoIdentificador,
    motivoDescricao: data.motivoInativacaoIdentificadorDescricao,
    novoCodigo: data.novoCodigoIdentificador,
    ...data.endereco
  }
  const response = await gqlMutate(gqlSubstituirIdentificador, payload)
  const feedback = response.data.identificadorSubstituir

  if (feedback.error.length > 0) {
    const errorFeedback = {
      title: feedback.error[0].codigo,
      message: feedback.error[0].message
    }
    const err = new Error('Erro ao bloquear VeloeTag')
    err.json = async () => errorFeedback
    throw err
  }

  return feedback
}

export async function inactiveIdentifier(data) {
  const payload = {
    quantidadeIdentificadores: 1,
    codigoIdentificador: data.codigoIdentificador,
    motivoInativacaoIdentificador: data.motivoInativacaoIdentificador,
    motivoInativacaoIdentificadorDescricao: data.motivoInativacaoIdentificadorDescricao,
    id: data.codigoConta
  }
  const response = await gqlMutate(gqlDesabilitarIdentificador, payload)

  return { result: response.data.identificadorInativar.result }
}



// WEBPACK FOOTER //
// ./src/alelo-logic/services/activationService.js